import React from 'react';

import { Text, TextProps } from '@/components/TextComponent';
import { useOptionName } from '@/feature/event-details-sbk/hooks/use-option-name';
import { useShallow } from 'zustand/react/shallow';

import { EMPTY_MARKET_TYPE } from '../hooks/use-bet-slip-market-name';
import { useSbkBetSlipStore } from '../hooks/use-sbk-betslip-store';

type OptionNameProps = TextProps & { optionId: string };

const EMPTY_OPTION_TYPE = { code: '', params: {} } as const;
const EMPTY_TEAM = {} as const;

export const OptionName = ({ optionId, ...textProps }: OptionNameProps) => {
    const optionNameParams = useSbkBetSlipStore(
        useShallow(state => {
            const option = state.options[optionId];
            const selection = state.selections[optionId];
            const event = state.events[selection?.eventId];
            const market = state.markets[selection?.marketId];
            const sportName = event?.sport?.name;
            return {
                optionType: option?.optionType ?? EMPTY_OPTION_TYPE,
                marketType: market?.marketType ?? EMPTY_MARKET_TYPE,
                homeTeam: event?.home_team ?? EMPTY_TEAM,
                awayTeam: event?.away_team ?? EMPTY_TEAM,
                fallback: option?.description ?? '',
                sportName,
            };
        })
    );
    const optionName = useOptionName(optionNameParams);

    return (
        <Text {...textProps} testID="optionName">
            {optionName}
        </Text>
    );
};
